import React, { useState, useEffect } from "react" ;
import  styles  from "../TextWithEllipses/ellipses.module.scss";

export default function TextWithEllipse({ text }) {
    const [showFullText, setShowFullText] = useState(false);
    const [limit, setLimit] = useState(false);
    useEffect(() => {
        //OS-2972 : show ...more only if text is more than 150 character        
        var element = document.querySelector('.text-with-ellipse');
        if ((element.offsetHeight < element.scrollHeight) || (element.offsetWidth < element.scrollWidth)) {
            // your element have overflow
            setLimit(true);
        }
        else {
            setLimit(false)
         }
        
    })

    const handleClick = () => {
        setShowFullText(!showFullText);
    }
    return (
        <>
            <span className={`text-with-ellipse xx-small-xs ${showFullText ? "" :styles.ellipse}`} dangerouslySetInnerHTML={{__html:text}}>
            </span>
            {!showFullText&&limit&&<span className={styles.text_more} onClick={handleClick}><span className="hover xx-small">...more</span></span>}
        </>
    )
}
